import { CheckCircle, Star, Award } from 'lucide-react';

const Hero = () => {
  return (
    <section id="anasayfa" className="relative bg-gradient-to-br from-blue-50 to-blue-100 min-h-screen flex items-center py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Profesyonel 
              <span className="text-blue-600"> Temizlik</span> Hizmetleri
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              18 yıllık deneyimimizle ev, ofis ve işyeri temizlik hizmetlerinde güvenilir çözüm ortağınız. 
              Kaliteli hizmet, uygun fiyat ve müşteri memnuniyeti garantisi.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-center space-x-2">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">Sigortalı ve Güvenli</span>
              </div>
              <div className="flex items-center space-x-2">
                <Star className="text-yellow-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">5 Yıldız Müşteri Memnuniyeti</span>
              </div>
              <div className="flex items-center space-x-2">
                <Award className="text-blue-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">Sertifikalı Personel</span>
              </div>
              <div className="flex items-center space-x-2">
                <CheckCircle className="text-green-500 flex-shrink-0" size={20} />
                <span className="text-gray-700">7/24 Hizmet</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8 transform rotate-2 hover:rotate-0 transition-transform duration-300">
              <img 
                src="https://images.pexels.com/photos/4239091/pexels-photo-4239091.jpeg?auto=compress&cs=tinysrgb&w=600" 
                alt="Profesyonel temizlik hizmetleri" 
                className="w-full h-64 object-cover rounded-xl"
              />
              <div className="mt-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Neden Bizi Seçmelisiniz?</h3>
                <p className="text-gray-600 leading-relaxed">
                  Modern ekipmanlar, çevre dostu temizlik ürünleri ve deneyimli ekibimizle 
                  her zaman en iyi hizmeti sunuyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;